import { useQuery } from '@tanstack/react-query';
import type { RestaurantAccessState } from '@restaurant/api-client';
import { openapiClient, unwrapResult } from '@/api/openapi-client';

export function useAccessState(restaurantId: string) {
  return useQuery({
    queryKey: ['restaurant-access-state', restaurantId],
    queryFn: async () =>
      unwrapResult<RestaurantAccessState>(
        await openapiClient.GET('/api/restaurants/{restaurantId}/access-state', {
          params: { path: { restaurantId } },
        }),
      ),
    refetchInterval: 60_000,
    refetchOnWindowFocus: 'always',
  });
}
